import { useState } from 'react';
import { motion } from 'framer-motion';
import { galleryImages } from '../../../mocks/portfolio';

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  
  const filters = ['All', 'Headshots', 'Production Stills', 'Behind the Scenes'];
  
  const filteredImages = activeFilter === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeFilter);

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif text-6xl md:text-7xl font-thin text-center text-gray-900 mb-12"
        >
          Gallery
        </motion.h2>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeFilter === filter
                  ? 'bg-black text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {filteredImages.map((image, index) => (
            <motion.div
              key={image.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className={`relative group overflow-hidden rounded-xl cursor-pointer ${
                image.size === 'large' ? 'col-span-2 row-span-2' : 
                image.size === 'wide' ? 'col-span-2' : ''
              }`}
            >
              <div className={`w-full ${
                image.size === 'large' ? 'h-[600px]' : 
                image.size === 'wide' ? 'h-[300px]' : 'h-[300px]'
              }`}>
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-center">
                  <h3 className="text-white text-lg font-semibold">{image.title}</h3>
                  <p className="text-white/80 text-sm mt-1">{image.category}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;